// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

const getHeightVal = (aspectRatioObj, variation, heightVal, shouldOverrideMaxHeight) => {
  const { aspectRatioD, aspectRatioT, aspectRatioM } = !isEmpty(aspectRatioObj) && aspectRatioObj;
  const aspectMap = {
    MOBILE: aspectRatioM,
    TABLET: aspectRatioT,
    DESKTOP: aspectRatioD,
  };
  const aspect = aspectMap[variation];
  if (aspect) {
    return `height: 100%;`;
  }

  if (heightVal && shouldOverrideMaxHeight) {
    return 'max-height: 500px; position: relative;';
  }

  return `
  height: ${heightVal ? `${heightVal}px` : `100%`};
  max-height: ${heightVal ? `${heightVal}px` : `100%`};`;
};

const getObjectFit = ({ imageFitTypeOverride }) => {
  if (!isEmpty(imageFitTypeOverride)) return imageFitTypeOverride.imageFitType;
  return 'contain';
};

export const TileContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex: 1;
  transition: opacity 0.8s ease;
  ${(props) => (props.isDimmed ? `opacity: 0.5` : `opacity: 1`)};
  ${(props) =>
    props.isCarouselDesign
      ? `
    width: 180px;
    height: 180px;
    @media ${props.theme.mediaQuery.medium} {
      width: ${props.carouseItemHeight}px;
      height: ${props.carouseItemHeight}px;
    }
  `
      : `
    @media ${props.theme.mediaQuery.smallMax} {
      ${props?.isEspotTile ? `margin-top: 22px;` : ``}
      ${getHeightVal(props?.aspectRatioObj, 'MOBILE', props.tileHeight)}
    }
    @media ${props.theme.mediaQuery.medium} {
      ${props.badgeHeight ? `margin-top: ${props.badgeHeight}px;` : ``}
      ${getHeightVal(props?.aspectRatioObj, 'TABLET', props.tileHeight)}
    }
    @media ${props.theme.mediaQuery.large} {
      ${props.badgeHeight ? `margin-top: ${props.badgeHeight}px;` : ``}
      ${getHeightVal(
        props?.aspectRatioObj,
        'DESKTOP',
        props.tileHeight,
        !(props.isFullRowView || props.shouldAllowMaxHeight)
      )}

      .product-card-button {
        ${({ isFullRowView, shouldAllowMaxHeight }) =>
          !(isFullRowView || shouldAllowMaxHeight) && 'max-height: 500px;'}
      }
    }
  `}
`;

export const CardImage = styled.img`
  object-fit: ${(props) => getObjectFit(props)};
  display: block;
  ${(props) =>
    props.isCarouselDesign
      ? `
      max-width: 180px;
      max-height: 180px;
      @media ${props.theme.mediaQuery.medium} {
        max-width: ${props.carouselItemImageSize}px;
        max-height: ${props.carouselItemImageSize}px;
      }
  `
      : `
    width: 100%;
    @media ${props.theme.mediaQuery.smallMax} {
      ${getHeightVal(props?.aspectRatioObj, 'MOBILE', props.imageHeight)}
    }
    @media ${props.theme.mediaQuery.medium} {
      ${getHeightVal(props?.aspectRatioObj, 'TABLET', props.imageHeight)}
    }
    @media ${props.theme.mediaQuery.large} {
      ${getHeightVal(props?.aspectRatioObj, 'DESKTOP', props.imageHeight)}
    }
  `}
`;
